import shortenedLabels from "./shortenLabelName/shortenedLabels.json"

const shortenLabelName = (originalLabelName) => {
  if (shortenedLabels.hasOwnProperty(originalLabelName)) {
    return shortenedLabels[originalLabelName]
  } else {
    return originalLabelName
  }
};

export default shortenLabelName;